/** @flow */

import {
  GetDefaultStandardScripts,
  GetDefaultStandardScriptsSuccess,
  GetDefaultStandardScriptsError,
  GetDefaultStandardScriptSuccess,
  GetDefaultStandardScriptError,
  ToggleEditDefaultStandardScriptModal,
  UpdateDefaultStandardScriptDraft,
  UpdateDefaultStandardScriptError,
} from "@modules/service/constants/actions";
import * as standardDefaultScriptsReducers from "./reducers";
import initialState from "./state";
import type { DefaultStandardScriptsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: DefaultStandardScriptsState = initialState,
  action: Object,
): DefaultStandardScriptsState => {
  const act = {
    [GetDefaultStandardScripts]: standardDefaultScriptsReducers.onGetDefaultStandardScripts,
    [GetDefaultStandardScriptsSuccess]:
      standardDefaultScriptsReducers.onGetDefaultStandardScriptsSuccess,
    [GetDefaultStandardScriptsError]:
      standardDefaultScriptsReducers.onGetDefaultStandardScriptsError,
    [GetDefaultStandardScriptSuccess]:
      standardDefaultScriptsReducers.onGetDefaultStandardScriptSuccess,
    [GetDefaultStandardScriptError]: standardDefaultScriptsReducers.onGetDefaultStandardScriptError,
    [ToggleEditDefaultStandardScriptModal]:
      standardDefaultScriptsReducers.onToggleEditDefaultStandardScriptModal,
    [UpdateDefaultStandardScriptDraft]:
      standardDefaultScriptsReducers.onUpdateDefaultStandardScriptDraft,
    [UpdateDefaultStandardScriptError]:
      standardDefaultScriptsReducers.onUpdateDefaultStandardScriptError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
